export default __webpack_public_path__ + "static/media/Rubik-Regular.a4bece5c.ttf";